(function () {
  var roots = document.querySelectorAll('[data-ss-reel]');
  if (!roots.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  Array.prototype.forEach.call(roots, function (root) {
    var rail = root.querySelector('[data-ss-reel-rail]');
    if (!rail) return;
    var videos = Array.prototype.slice.call(root.querySelectorAll('video'));

    function attachPoster(v) {
      var p = v.getAttribute('data-poster');
      if (p) {
        v.poster = p;
        v.removeAttribute('data-poster');
      }
    }

    function play(v) {
      attachPoster(v);
      if (v.preload === 'none') {
        v.preload = 'auto';
        v.load();
      }
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    /* Releases the buffer for a clip that has scrolled well away. Without this
       a long browse leaves a dozen decoded clips resident, which is what makes
       a phone get hot and then stutter. Only ever called on muted clips, and
       the poster is already attached by then so the tile does not go blank. */
    function unload(v) {
      if (!v.paused) v.pause();
      if (v.preload !== 'none') {
        v.preload = 'none';
        v.removeAttribute('src');
        v.load();
      }
    }

    function silenceAll(except) {
      videos.forEach(function (o) {
        if (o === except) return;
        o.muted = true;
        var b = o.parentNode.querySelector('[data-ss-reel-sound]');
        if (b) b.setAttribute('aria-pressed', 'false');
        o.parentNode.parentNode.classList.remove('is-loud');
      });
    }

    if (hasIO) {
      // Posters attach a little before the tile arrives, so scrolling the rail
      // never shows an empty box, but a homepage with 30-odd clips does not
      // download 30-odd poster images on load.
      var nearRail = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              attachPoster(e.target);
              nearRail.unobserve(e.target);
            }
          });
        },
        { root: rail, rootMargin: '0px 600px 0px 600px' }
      );
      videos.forEach(function (v) {
        if (v.getAttribute('data-poster')) nearRail.observe(v);
      });

      if (!reduce) {
        /* ONE CLIP PLAYS AT A TIME. This used to play every clip that was 40%
           inside the rail, which on a rail showing about two and a half tiles
           meant two or three clips streaming at once. Measured against the live
           files that was up to 20MB of concurrent video on a phone, and the
           result was clips that buffered forever or never started at all.

           Now every clip reports its ratio, the most-visible one plays, and the
           rest pause. A clip the visitor has un-muted is left alone: she chose
           it, so it keeps playing even as she scrolls the rail. */
        var ratios = new WeakMap();
        var visible = [];

        function pickOne() {
          var best = null;
          var bestRatio = 0;
          visible.forEach(function (v) {
            var r = ratios.get(v) || 0;
            if (r > bestRatio) { bestRatio = r; best = v; }
          });
          videos.forEach(function (v) {
            if (!v.muted) return;
            if (v === best && bestRatio >= 0.5) {
              play(v);
            } else if (!v.paused) {
              v.pause();
            }
          });
        }

        var inRail = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              ratios.set(e.target, e.isIntersecting ? e.intersectionRatio : 0);
              var at = visible.indexOf(e.target);
              if (e.isIntersecting && at === -1) visible.push(e.target);
              if (!e.isIntersecting && at !== -1) visible.splice(at, 1);
            });
            pickOne();
          },
          { root: rail, threshold: [0, 0.25, 0.5, 0.75, 1] }
        );
        videos.forEach(function (v) { inRail.observe(v); });

        /* Clips far outside the rail give their buffers back. */
        var farAway = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              if (!e.isIntersecting && e.target.muted) unload(e.target);
            });
          },
          { root: rail, rootMargin: '0px 1200px 0px 1200px' }
        );
        videos.forEach(function (v) { farAway.observe(v); });

        // Nothing plays at all once the section leaves the page.
        var onPage = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              if (!e.isIntersecting) {
                videos.forEach(function (v) { v.pause(); });
                silenceAll(null);
              } else {
                pickOne();
              }
            });
          },
          { threshold: 0 }
        );
        onPage.observe(root);

        /* A backgrounded tab should not be streaming video. */
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) {
            videos.forEach(function (v) { v.pause(); });
          } else {
            pickOne();
          }
        });
      }
    }

    // The sound button also starts the clip, which is what makes the rail
    // usable when the visitor has asked for reduced motion and nothing is
    // autoplaying.
    root.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-ss-reel-sound]') : null;
      if (!btn) return;
      e.preventDefault();
      var wrap = btn.parentNode;
      var v = wrap.querySelector('video');
      if (!v) return;
      var tile = wrap.parentNode;

      if (v.paused || v.muted) {
        silenceAll(v);
        v.muted = false;
        btn.setAttribute('aria-pressed', 'true');
        btn.setAttribute('aria-label', 'Mute this clip');
        tile.classList.add('is-loud');
        play(v);
      } else {
        v.muted = true;
        btn.setAttribute('aria-pressed', 'false');
        btn.setAttribute('aria-label', 'Play this clip with sound');
        tile.classList.remove('is-loud');
      }
    });

    // Arrows step by whole tiles rather than a guessed pixel amount.
    Array.prototype.forEach.call(root.querySelectorAll('[data-ss-reel-nav]'), function (btn) {
      btn.addEventListener('click', function () {
        var tile = rail.querySelector('.ss-reel__tile');
        if (!tile) return;
        var styles = window.getComputedStyle(rail);
        var gap = parseFloat(styles.columnGap || styles.gap) || 12;
        var step = tile.getBoundingClientRect().width + gap;
        var dir = btn.getAttribute('data-ss-reel-nav') === 'next' ? 1 : -1;
        rail.scrollBy({ left: dir * step * 2, behavior: reduce ? 'auto' : 'smooth' });
      });
    });

    function syncNav() {
      var prev = root.querySelector('[data-ss-reel-nav="prev"]');
      var next = root.querySelector('[data-ss-reel-nav="next"]');
      if (!prev || !next) return;
      var max = rail.scrollWidth - rail.clientWidth - 2;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max;
    }
    rail.addEventListener('scroll', syncNav, { passive: true });
    window.addEventListener('resize', syncNav, { passive: true });
    syncNav();
  });
})();